var _g, _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPawIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 43,
    viewBox: "0 0 41 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1883_7753)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20.4589,
    cy: 19.9989,
    r: 16.7568,
    fill: "#108F75"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.4589,
    cy: 19.9989,
    r: 17.5268,
    stroke: "#117863",
    strokeWidth: 1.54
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3691 17.1624C22.6416 16.8506 24.0729 23.895 20.5903 28.0021C19.2693 29.5595 16.7786 29.6915 15.6514 27.8561C14.8125 26.4893 14.4332 25.6784 13.0537 24.6952C12.0753 23.9981 10.9974 23.8282 10.4885 22.6148C9.09402 19.293 13.7497 17.2927 16.3691 17.1624Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5085 14.6912C28.5764 14.5955 29.64 15.0995 29.9667 16.1529C30.5725 18.1037 28.7443 20.4018 26.9245 20.9924C24.4095 21.8082 22.8144 19.925 23.7845 17.5626C24.3627 16.1529 25.9461 14.8314 27.5094 14.6912H27.5085Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.74 9.64062C23.609 9.65465 24.4287 10.0951 24.7712 10.9076C26.0714 13.9952 20.8951 17.9224 18.8405 15.3216C17.095 13.1109 20.2116 9.59938 22.74 9.64145V9.64062Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.575 10.1621C16.2002 9.9914 17.0407 11.4448 16.831 12.8843C16.592 14.5241 14.8741 16.4123 13.0702 15.7416C10.5318 14.7988 11.9848 10.4335 14.5742 10.1621H14.575Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2992 22.6798C28.3862 22.688 29.4632 23.3603 29.561 24.5019C29.7966 27.281 25.024 29.0421 23.9352 26.5138C23.0805 24.5275 25.4409 22.6649 27.2992 22.6798Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1883_7753",
    x: -0.0000529289,
    y: 1.70312,
    width: 40.9181,
    height: 40.9181,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.16216
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.08108
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1883_7753"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1883_7753",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPawIcon);
export default __webpack_public_path__ + "static/media/pawIcon.e8bd65881f8ee364f4d1fd5340a492ac.svg";
export { ForwardRef as ReactComponent };